import {useClientRoute} from '@/hooks/auth/useClientRoute';
import {routes} from 'ff-common';
import {useMemo} from 'react';

// utilisation de buildClientRoute au lieu de buildRoute pour supporter le mode d'assistance
export const useNavigatePanier = () => {
  const {buildClientRoute} = useClientRoute();

  const navigatePanier = useMemo(() => {
    return (date_de_livraison: string | undefined) => {
      if (!date_de_livraison)
        return buildClientRoute(routes.client.panier_default);
      return buildClientRoute(routes.client.panier, {
        date_panier_actif: date_de_livraison,
      });
    };
  }, [buildClientRoute]);

  return navigatePanier;
};
